<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h3>Application details</h3>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4" label="Name" v-model="data_local.ApplicationName"
                  v-validate="'required'"
                  name="ApplicationName" />
        <validation-message v-show="vErrors.has('ApplicationName')">
          {{ vErrors.first("ApplicationName") }}
        </validation-message>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input class="w-full mt-4" label="Description"
                  v-model="data_local.ApplicationDescription"
                  v-validate="'required'"
                  name="ApplicationDescription" />
        <validation-message v-show="vErrors.has('ApplicationDescription')">
          {{ vErrors.first("ApplicationName") }}
        </validation-message>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4" label="Client ID" :value="data_local.ExternalIdentity_Key"
                  readonly
                  disabled
                  name="ExternalIdentity_Key" />
      </div>
      <div class="vx-col w-1/2 mt-4">
        <label class="vs-input--label mt-4">Application Type</label>
        <v-select v-model="application_type_local"
                  :clearable="false"
                  :options="applicationTypeOptions"
                  v-validate="'required'"
                  name="app_type" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        <validation-message v-show="vErrors.has('app_type')">
          {{ vErrors.first("app_type") }}
        </validation-message>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4"
                  label="Client Secret"
                  :value="data_local.ExternalIdentity.client_secret"
                  readonly
                  disabled
                  name="Secret" />
      </div>
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4"
                  label="Application Login URI" :value="data_local.ExternalIdentity.initiate_login_uri"
                  readonly
                  name="initiate_login_uri" />
        <validation-message v-show="vErrors.has('initiate_login_uri')">
          {{ vErrors.first("initiate_login_uri") }}
        </validation-message>
      </div>
    </div>

  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      applicationId: null,
      applications: [],
      applicationTypeOptions: [
        {
          label: 'Machine to Machine',
          value: 'non_interactive',
        },
        {
          label: 'Native',
          value: 'native',
        },
        {
          label: 'Regular Web Application',
          value: 'regular_web',
        },
        {
          label: 'Single Page Application',
          value: 'spa',
        },
      ]
    }
  },
  computed: {
    application_type_local: {
      get () {
        return this.applicationTypeOptions
            .find(({ value }) => value === this.data_local.ExternalIdentity.app_type);
      },
      set ({ value }) {
        this.data_local.ExternalIdentity.app_type = value;
      }
    },
    application() {
        return this.data.applications.length ? this.data.applications[0] : null;
    },
    validateForm () {
      return !this.vErrors.any()
    },
    applicationsOptions() {
      return this.applications.map(({ id, ApplicationName }) => { return { label: ApplicationName, value: id }  });
    },
    id() {
      return this.data.id;
    }
  },
  watch: {
    data_local: {
      handler(newData) {
        this.$emit('input', newData);
      },
      deep: true,
    },
  },
  created() {
  },
  methods: {
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },

  }
}
</script>
